import { Box, Typography, List, ListItem, ListItemText, ListItemIcon } from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';

const featuresData = {
    admin: [
        "Create and manage places (e.g., clinics, salons)",
        "Add and manage service providers",
        "Define provider availability",
        "Define services per place with custom price and duration",
        "Manage appointments via daily & monthly calendar views",
        "Add clients and book appointments directly",
        "Edit existing bookings and manage availability",
        "Manage payments, including loyalty points redemption",
        "Configure Client Club/Loyalty Program (referrals, redeem, and earn points)",
        "Register unlimited specialists, service providers, and clients",
        "View Appointments Report",
        "View Payments Report",
        "View Loyalty Report",
        "View Referrals Report",
        "View Debtors Report"
    ],
    client: [
        "Search for places (clinics, salons, etc.) offering appointments",
        "View service providers at a selected place",
        "See available time slots using the calendar",
        "Book a pending appointment and wait for confirmation",
        "Track status of all appointments (Pending, Confirmed, etc.)"
    ]
};

const Features: React.FC = () => {

    return (
        <Box component="section" className="home-section" >
            <Typography variant="h4" align="center" sx={{ fontWeight: "bold", }} >
                Features
            </Typography>
            <Box display='flex' flexDirection='row' flexWrap='wrap' justifyContent='space-around' >
                <Box sx={{ maxWidth: '500px' }} >
                    <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>As an admin:</Typography>
                    <List sx={{ pl: 2 }} style={{ backgroundColor: 'inherit' }}>
                        {featuresData.admin.map((item, index) => (
                            <ListItem disablePadding key={index} >
                                <ListItemIcon>
                                    <CheckIcon />
                                </ListItemIcon>
                                <ListItemText primary={item} />
                            </ListItem>
                        ))}
                    </List>
                </Box>
                <Box sx={{ maxWidth: '500px' }} >
                    <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 'bold' }}>As a client:</Typography>
                    <List sx={{ pl: 2 }} style={{ backgroundColor: 'inherit' }}>
                        {featuresData.client.map((item, index) => (
                            <ListItem disablePadding key={index} >
                                <ListItemIcon>
                                    <CheckIcon />
                                </ListItemIcon>
                                <ListItemText primary={item} />
                            </ListItem>
                        ))}
                    </List>
                </Box>
            </Box>
        </Box>
    );
};

export default Features;